const dashboardStats = (state) => state.dashboardStats

export default {
  dashboardStats
}



// WEBPACK FOOTER //
// ./src/store/modules/superAdminDashboard/getters.js